var checks = {};

module.exports = function(src, callback) {
  if (src in checks) {
    return callback(checks[src]);
  }

  var img = new Image();

  img.onload = function() {
    checks[src] = true;
    callback(true);
  };

  img.onerror = function() {
    checks[src] = false;
    callback(false);
  };

  img.src = src;
};



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/image-exists/index.js
// module id = 905
// module chunks = 0 3 5